import { Grid, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import './Filters.css';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Select from 'react-select';
import { axiosFetch } from '../../../../../utils/AxiosFetch';
import { useNavigate } from 'react-router';
import { CustomizedSnackbar } from "../../../../../shared";
import { PeriodList } from '../../../../../utils/PeriodList';
import { useDispatch } from 'react-redux';
import { SnackbarActions } from '../../../../../redux/actions/snackbar.actions';

const Filters = (props) => {
    var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";

    const navigate = useNavigate();
    const dispatch = useDispatch();


    const [departmentList, setDepartmentList] = useState([]);
    const [teamList, setTeamList] = useState([]);
    const [keyword, setKeyword] = useState("");

    const [selectedDept, setSelectedDept] = useState(null);
    const [selectedTeam, setSelectedTeam] = useState(null);
    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [periodOption, setPeriodOption] = useState([]);



    const handleChangeTeam = (obj) => {
        setSelectedTeam(obj);
        props.handleChangeTeamId(obj.value);
    };

    const handleChangePeriod = (obj) => {
        setSelectedPeriod(obj);
        props.handleChangeYear(obj.value.split("-")[0]);
        props.handleChangeDateFilter(obj.value.split("-")[1]);
    };

    const handleChangeKeyword = (e) => {
        setKeyword(e.target.value);
        props.handleChangeKeyword(e.target.value);
    }


    const loadDepartments = () => {
        axiosFetch({
            method: "get",
            url: "/Lookup/departments"
        })
            .then((res) => {
                if (res.status === 200) {
                    setDepartmentList(res.data);
                }
                // else if (res.status === 400) {
                //     dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                // }

                else if (res.status === 401) {
                    navigate('/');
                }
            })
            .catch(err => {
                console.error(err);
            })
    }

    const loadTeams = (id) => {
        axiosFetch({
            method: "get",
            url: `/Lookup/department/teams/${id}`
        })
            .then((res) => {
                if (res.status === 200) {
                    setTeamList(res.data);
                }
                // else if (res.status === 400) {
                //     dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                // }
                else if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch(err => {
                console.error(err);
            })
    }
    const handleChangeDepartment = (obj) => {
        setSelectedDept(obj);
        loadTeams(parseInt(obj.value));
        props.handleChangeDepartmentId(obj.value);

    }

    const clearAll = () => {

        setSelectedPeriod(null);
        setSelectedTeam(null);
        setKeyword("");
        setSelectedDept(null);

        props.handleChangeKeyword("");
        props.handleChangeTeamId("");
        props.handleChangeDepartmentId("");
        props.handleChangeYear("");
        props.handleChangeDateFilter("");
        props.loadTeamForm(1);

        getCurrentSessionDetails()

    }

    function getCurrentSessionDetails() {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;
        var value = null;
        if (currentMonth <= 6) {
            value = {
                lable: currentYear + "-" + 'H1',
                value: currentYear + "-" + 'H1'
            }

        }
        else {
            value = {
                lable: currentYear + "-" + 'H2',
                value: currentYear + "-" + 'H2'
            }

        }

        var list = PeriodList(3, "half");
        console.log(list);
        var restrictYear = null;
        var exactperiod;
        if (currentMonth <= 6) {
            restrictYear = {
                lable: currentYear + "-" + 'H2',
                value: currentYear + "-" + 'H2'
            }

        }
        if(restrictYear !== null){
            exactperiod = list.filter(list => list.value !== restrictYear.value);
        }else{
            exactperiod = list;
        }

        const res = list.filter(list => list.value === value.value)[0];
        console.log(res)
        props.handleChangeYear(res.value.split("-")[0]);
        props.handleChangeDateFilter(res.value.split("-")[1]);
        setSelectedPeriod(res);
        setPeriodOption(exactperiod)

    }

    useEffect(() => {
        getCurrentSessionDetails();
        loadDepartments();
        getPeriodList();

    }, []);

    const getPeriodList = () => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;
        var list = PeriodList(3, "half");
        console.log(list);
        var restrictYear = null;
        var exactperiod;
        if (currentMonth <= 6) {
            restrictYear = {
                lable: currentYear + "-" + 'H2',
                value: currentYear + "-" + 'H2'
            }

        }
        if(restrictYear !== null){
            exactperiod = list.filter(list => list.value !== restrictYear.value);
        }else{
            exactperiod = list;
        }
         setPeriodOption(exactperiod)
    }

    return (
        <div className='filter' style={{ marginTop: "0px" }}>
            {/* dept, period, team,keywords */}
            {/* <Card className='filters'> */}
            <h3 className='filters'>Filters</h3>
            <ValidatorForm>
                <Grid container xs={12} spacing={2} className='va-bt'>
                    {isUserLogged.usertype === "HRManager" || isUserLogged.usertype === "SuperAdmin"?
                    <Grid item xs={3}>
                        <TextValidator className='custom-height-input' fullWidth placeholder='Search Keywords' value={keyword} onChange={handleChangeKeyword} />
                    </Grid>:""}
                    {isUserLogged.usertype === "HRManager" || isUserLogged.usertype === "SuperAdmin"?
                    <Grid item xs={3}>
                        <Select placeholder="Select Department" options={departmentList} onChange={handleChangeDepartment} value={selectedDept} />
                    </Grid>:""}
                    {isUserLogged.usertype === "HRManager" || isUserLogged.usertype === "SuperAdmin"?
                    selectedDept === null ? "" : <Grid item xs={3}>
                        <Select placeholder="Select Team" options={teamList} onChange={handleChangeTeam} value={selectedTeam} />
                    </Grid>:""}
                    <Grid item xs={3}>
                        <Select placeholder="Select Period" options={periodOption} onChange={handleChangePeriod} value={selectedPeriod} />
                    </Grid>
                    <Grid item xs={3}>
                    <Button className='theme-btn cancel-btn' variant="contained" onClick={() => clearAll()} >Clear</Button>
                    <Button className='theme-btn' sx={{ marginRight: "10px" }} variant="contained" onClick={() => props.loadTeamForm()}>Search</Button>
                    </Grid>
                   
                </Grid>
                {/* <Grid container xs={12} spacing={2} sx={{ display: "flex", justifyContent: "center", margin: "10px 0" }}>
                    <Button className='theme-btn cancel-btn' variant="contained" onClick={() => clearAll()} >Clear</Button>&nbsp;&nbsp;
                    <Button className='theme-btn' sx={{ marginRight: "10px" }} variant="contained" onClick={() => props.loadTeamForm()}>Search</Button>
                  
                </Grid> */}
            </ValidatorForm>
            {/* </Card> */}
            <CustomizedSnackbar />
        </div>
    )
}

export default Filters;